import { PlaidMerchantInfoResponse } from 'merchant-api/types';
import { useParties } from 'merchant-api/spiceroad';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface PlaidMerchantInfoResponseProps {
  isPlaidMerchantInfoResponseMutating: boolean;
  isPlaidMerchantInfoResponseError: Error | null;
  plaidMerchantInfoResponse: PlaidMerchantInfoResponse | undefined;
  getPlaidMerchantInfo: Function;
  mutation: UseMutationResult<PlaidMerchantInfoResponse, Error, void>;
}

export function getPlaidInfo(): PlaidMerchantInfoResponseProps {
  const { isRenewal } = useParties();

  const mutation = useMutation({
    mutationFn: () =>
      spiceroad
        .get<PlaidMerchantInfoResponse>('/v1/plaid/merchant-info')
        .then((res) => res.data),
    mutationKey: ['plaidMerchantInfo'],
  });

  return {
    isPlaidMerchantInfoResponseMutating: mutation.isPending,
    isPlaidMerchantInfoResponseError: mutation.error,
    plaidMerchantInfoResponse: mutation.data,
    getPlaidMerchantInfo: mutation.mutateAsync,
    mutation,
  };
}

export default getPlaidInfo;
